import React from "react";

const Loader = ({ dimensions, color }) => {
    return (
        <div className="loader-container">
            <div className="loader" style={{
                width: dimensions,
                height: dimensions,
                background: `conic-gradient(from 0deg, ${color}, rgba(144, 79, 237, 0.05), ${color})`
            }}></div>
        </div>
    );
};

export default Loader;
